import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M2.25 4A.75.75 0 0 1 3 3.25h18a.75.75 0 0 1 0 1.5H3A.75.75 0 0 1 2.25 4m4 5A.75.75 0 0 1 7 8.25h14a.75.75 0 0 1 0 1.5H7A.75.75 0 0 1 6.25 9m-4 5a.75.75 0 0 1 .75-.75h18a.75.75 0 0 1 0 1.5H3a.75.75 0 0 1-.75-.75m4 5a.75.75 0 0 1 .75-.75h14a.75.75 0 0 1 0 1.5H7a.75.75 0 0 1-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }